export default {"src":"/_next/static/media/roundCheckMark.143d4b68.svg","height":20,"width":20};